export { ARROW_SIZES } from "@frontend/components/atoms/DatePicker/constants";

export const MONTH_PICKER_TAG_NAME = "month-picker" as const;

export const MONTH_PICKER_LAYOUTS = ["default", "text"] as const;

export const MONTHS_PER_ROW = 3;
